import React, { createContext, useContext, useEffect, useState } from "react";

const PrivacyCtx = createContext(null);

export function PrivacyProvider({ children }) {
  const [hidden, setHidden] = useState(() => localStorage.getItem("cf_hide_values") === "1");
  useEffect(() => {
    localStorage.setItem("cf_hide_values", hidden ? "1" : "0");
  }, [hidden]);
  const toggle = () => setHidden((v) => !v);
  return <PrivacyCtx.Provider value={{ hidden, toggle }}>{children}</PrivacyCtx.Provider>;
}

export const usePrivacy = () => useContext(PrivacyCtx);
